/* globals $, window */
define('main',['populateData', 'apiController', 'menuController', 'popupController'],
    function(populateData, apiController, MenuController, popupController) {
    	popupController.init();
        apiController.getPromotions().then(function(res) {
            populateData.populatePageApiData(res);
            //Go to promotion if in url
            if(window.location.hash.indexOf("#promotion-" > -1)){
                window.setTimeout(function(){
                    jumpToPromotion(window.location.hash);
                },1600);
            }
            MenuController.initMenuBar();
        });

        function jumpToPromotion(hash){
            if($(hash) && $(hash).offset() && $(hash).offset().top){
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 400);
                // $(window).scrollTop($(hash).offset().top);
            }
        }
    });

